'use strict';
import React from 'react/addons';
import $ from 'jquery';

import BaseEntryPoint from 'ofs/apps/core/entry';
import HomesList from 'ofs/components/homeslist/HomesList';

import AvailabilityStore from './stores/AvailabilityStore';
import BookingQuoteStore from './stores/BookingQuoteStore';
import UnitStore from './stores/UnitStore';

import SimilarHomesStore from 'ofs/apps/homes/detail/stores/similar-homes';


import BookingForm from './views/BookingForm';


export default class EntryPoint extends BaseEntryPoint {
  getStores() {
    return Object.assign(super.getStores(), {
      AvailabilityStore: new AvailabilityStore(this.options.availability),
      BookingQuoteStore: new BookingQuoteStore(this.options.quote),
      UnitStore: new UnitStore(this.options.unit),
      SimilarHomes: new SimilarHomesStore(this.options.similar)
    });
  }

  renderToDocument(document) {
    super.renderToDocument(document);

    if (document.getElementById('similar-homes')) {
      React.render(
        <HomesList flux={this.flux} />,
        document.getElementById('similar-homes')
      );
    }

    if (document.getElementById('booking-form')) {
      React.render(
        <BookingForm flux={this.flux} />,
        document.getElementById('booking-form')
      );
    }
  }
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/legacy/property/default/entry.jsx
 **/